"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTerminalProjectStep = exports.TERMINAL_PROJECT_STEP_VALUES = exports.TERMINAL_PROJECT_STEPS = void 0;
const steps_1 = require("./steps");
/**
 * The steps a dossier never leaves — "terminé" and "abandonné".
 *
 * A refused / file-refused dossier is NOT terminal: `PROJECT_REFUSED` means
 * "awaiting client modification" and loops back through `request`
 * (see docs/knowledge/workflow-forks.md), so its work is still outstanding.
 */
exports.TERMINAL_PROJECT_STEPS = [
    steps_1.ProjectStep.PROJECT_COMPLETED,
    steps_1.ProjectStep.PROJECT_ABANDONED,
];
/**
 * The same set widened to the raw `project_steps_enum` values.
 *
 * `PROJECT_CLOSED` survives in the database enum from the pre-2024 lifecycle
 * and no code path writes it any more (zero rows carry it), so it is absent
 * from `ProjectStep`. Guards that read a step off the wire — Hasura event
 * payloads, SQL — still have to treat it as terminal, hence this list rather
 * than `TERMINAL_PROJECT_STEPS`.
 */
exports.TERMINAL_PROJECT_STEP_VALUES = [
    ...exports.TERMINAL_PROJECT_STEPS,
    'PROJECT_CLOSED',
];
/** True when `step` is one a dossier never leaves. Tolerates null/unknown. */
const isTerminalProjectStep = (step) => step != null && exports.TERMINAL_PROJECT_STEP_VALUES.includes(step);
exports.isTerminalProjectStep = isTerminalProjectStep;
//# sourceMappingURL=terminal-steps.js.map